import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerTeam } from '../services/api';

function TeamLogin() {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  // On load: try to restore the last used code from localStorage
  useEffect(() => {
    const savedCode = localStorage.getItem('teamCode');
    if (savedCode) {
      setCode(savedCode);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) {
      setMessage('Vul de unieke code in');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const response = await registerTeam(code.trim(), name.trim());
      
      if (response.data.success) {
        // Save code and other data for next time
        localStorage.setItem('teamCode', code.trim());
        localStorage.setItem('teamName', response.data.team_name);
        localStorage.setItem('teamId', response.data.team_id);

        navigate('/team/answers');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Fout bij registreren. Probeer opnieuw.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-6 -mt-16">
      <h1 className="text-4xl font-bold mb-12 text-center">
        Welkom bij de Pub Quiz!
      </h1>

      <form onSubmit={handleSubmit} className="w-full max-w-md">
        <div className="mb-6">
          <label className="block text-lg mb-2">Unieke code</label>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            placeholder="bijv. ABC123"
            className="w-full px-4 py-3 text-xl border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none uppercase"
            autoFocus
            disabled={loading}
          />
        </div>

        <div className="mb-8">
          <label className="block text-lg mb-2">Teamnaam (alleen bij eerste keer)</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="bijv. De slimste alpacas"
            className="w-full px-4 py-3 text-xl border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
            disabled={loading}
          />
          <p className="text-sm text-gray-600 mt-2">
            Als je al eerder hebt ingelogd, kun je dit veld leeg laten.
          </p>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-lg text-xl disabled:opacity-50"
        >
          {loading ? 'Bezig...' : 'Inloggen'}
        </button>

{message && (
  <div className={`mt-6 p-4 rounded-lg text-center text-lg font-semibold border-2 ${
    message.includes('Fout') || message.includes('Invalid') || message.includes('verkeerde')
      ? 'bg-red-100 border-red-500 text-red-700'
      : 'bg-green-100 border-green-500 text-green-700'
  }`}>
    {message}
  </div>
)}
      </form>

      <p className="mt-12 text-gray-600 text-center">
        Heb je nog geen code? Vraag hem op bij de quizmaster.
      </p>
    </div>
  );
}

export default TeamLogin;